// import { useLocation, Navigate, Outlet } from "react-router-dom";
// import { useAtom } from "jotai";
// import { loggedInUser } from "../utils/store";

// const RequireAuth = ({ allowedRoles }) => {
//   const [loggedUser] = useAtom(loggedInUser);
//   const location = useLocation();

//   if (!loggedUser || !Array.isArray(loggedUser.role)) {
//     return null;
//   }

//   return loggedUser?.role?.find((role) => allowedRoles?.includes(role)) ? (
//     <Outlet />
//   ) : loggedUser?.id ? (
//     <Navigate to="/unauthorized" state={{ from: location }} replace />
//   ) : (
//     <Navigate to="/login" state={{ from: location }} replace />
//   );
// };

// export default RequireAuth;

import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { loggedInUser } from "../utils/store";

const RequireAuth = ({ allowedRoles = [] }) => {
  const [loggedUser] = useAtom(loggedInUser);
  const location = useLocation();

  if (!loggedUser || !Array.isArray(loggedUser.role)) {
    return null;
  }

  // Not logged in → redirect to login
  if (!loggedUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Role check (safe)
  const userRoles = Array.isArray(loggedUser.role) ? loggedUser.role : [];

  const isAuthorized =
    allowedRoles.length === 0 ||
    userRoles.some((role) => allowedRoles.includes(role));

  // Logged in but not authorized
  if (!isAuthorized) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  // All good
  return <Outlet />;
};

export default RequireAuth;
